import { Injectable } from '@angular/core';
import { UrlTree, CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthStoreService } from '@motivforce/mx-library-angular';
import { filter, map, Observable, of, switchMap } from 'rxjs';

import { reAcceptTermsAndCondtions, User } from '../model/user';
import { UserStoreService } from '../store/user-store.service';
import { isNonNull } from './redeem-blocked.guard';

@Injectable({
  providedIn: 'root',
})
export class TaxRequirementsCompletedGuard implements CanActivate {
  constructor(private router: Router, private userStore: UserStoreService, private authStore: AuthStoreService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.authStore.isRegularUser$.pipe(
      filter(isNonNull),
      switchMap((isRegularUser: boolean) => {
        if (isRegularUser) {
          return this.userStore.taxRequirements$.pipe(
            filter(Boolean),
            map((taxRequirements) => {
              const user = this.authStore.userSettings?.user as User;
              if (
                taxRequirements.taxRequirementsCompleted ||
                (state.url.includes('/home') && (!user?.acceptedTermsConditions || reAcceptTermsAndCondtions(user)))
              ) {
                return true;
              }

              this.router.navigateByUrl('/my-leap');
              return false;
            })
          );
        }

        return of(true);
      })
    );
  }
}
